<div>
  <div class="input-group">
    <input set-focus type="search" id="search-box" autocomplete="off" (keyup)="search()" [(ngModel)]="searchTerm"
      placeholder="{{ 'app.search' | translate }}"
      [class]="smallMode ? 'form-control  form-control-sm' : 'form-control'">

    @if (!hideSettings) {
    <a class="input-group-addon" href="javascript:void(0)" data-toggle="modal" data-target="#searchOptions">
      <i class="fa fa-cog" aria-hidden="true"></i>
    </a>
    }
  </div>
  @switch (status) {
  @case ('ok') {
  @if ((parties && parties.length > 0) && !hideResults) {
  <div class="search-result">
    @if (!hideDetails) {
    <div>
      <a href="javascript:void(0)" data-toggle="modal" data-target="#resultDetails">
        {{ 'widgets.party-search.resultDetails' | translate }}
      </a>
    </div>
    }
    @for (party of parties; track $index) {
    <div (click)="selectParty(party)">
      {{ party.fullName }}
    </div>
    }
  </div>
  }
  @if (parties && parties.length == 0) {
  <div class="search-result" style="color: darkgray">
    {{ 'app.resultNotfound' | translate }}... <i class="fa fa-frown-o" aria-hidden="true"></i>
  </div>
  }
  }
  @case ('busy') {
  <div class="search-result spinneram" style="margin: 1px; width: 90%; text-align: center">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
    <!-- {{'app.loading-message'| translate}} -->
  </div>
  }
  }
</div>

<div id="searchOptions" class="modal fade">

  <div class="modal-dialog" role="document">

    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'app.search' | translate }}
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h5>
      </div>

      <div class="modal-body">

        <div class="row">

          <div class="col-sm-12">
            <h6>{{ 'widgets.party-search.partyStatus' | translate }}</h6>
            <div class="btn-group">
              <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                <span>{{ currentState.name | translate }}</span>
              </button>

              <div class="dropdown-menu">
                @for (state of partyStatus; track $index) {
                <a class="dropdown-item" href="javascript:void(0)" (click)="changeState(state)">
                  {{ state.name | translate }}
                </a>
                }
              </div>
            </div>
          </div>

          <div class="col-sm-12" style="height: 30px;"></div>

          @if (preferredTypes) {
          <div class="col-sm-12 ">
            <div style="max-height: 300px; overflow-y: auto;">
              <h6>{{ 'widgets.party-search.preferredTypes' | translate }}</h6>
              <table class="table table-sm">
                <tbody>
                  @for (t of preferredTypes; track $index) {
                  <tr>
                    <td class="text-xs-center">
                      <div class="checkbox">
                        <input type="checkbox" [(ngModel)]="t.selected">
                      </div>
                    </td>
                    <td>
                      {{ t.name }}
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          }

          <hr>
          <div class="col-sm-12">
            <a data-toggle="collapse" href="#otherTypes" aria-expanded="false" aria-controls="collapseExample">
              {{ 'widgets.party-search.otherTypes' | translate }}
            </a>
            <div id="otherTypes" class="collapse" style="max-height: 300px; overflow-y: scroll;">
              @if (relTypologies) {
              <table class="table table-sm">
                <tbody>
                  @for (t of relTypologies; track $index) {
                  <tr>
                    <td class="text-xs-center">
                      <div class="checkbox">
                        <input type="checkbox" [(ngModel)]="t.selected">
                      </div>
                    </td>
                    <td>
                      {{ t.name }}
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              }
            </div>
          </div>

          <div class="col-sm-12" style="height: 30px;"></div>

        </div>

      </div>

      <div class="modal-footer">
        <div class="pull-left">
          <input type="checkbox" [(ngModel)]="savePreference" />
          <small>
            Ricorda le mie scelte
          </small>
        </div>
        <button type="button" class="btn btn-default" data-dismiss="modal">
          {{ 'app.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="onConfirmOptions()">
          {{ 'app.confirm' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div id="resultDetails" class="modal fade">

  <div class="modal-dialog" role="document">

    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'widgets.party-search.resultDetails' | translate }}
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h5>
      </div>

      <div class="modal-body" style="height: 65%; max-height: 650px; overflow-y: auto;">
        <table class="table table-sm">
          <tbody>
            @for (party of parties; track $index) {
            <tr>
              <th colspan="2">
                <a href="javascript:void(0)" data-dismiss="modal" (click)="selectParty(party)">
                  {{ party.fullName }}
                </a>
              </th>
            </tr>
            <tr>
              <td>
              <td>
                @for (c of party.contacts; track $index) {
            <tr>
              <td>
                {{ c.purposeName }}
              </td>
              <td>
                {{ c.endPoint }}
              </td>
              <td>
                {{ c.name }}
              </td>
            </tr>
            }
            </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">
          {{ 'app.close' | translate }}
        </button>
      </div>
    </div>
  </div>

</div>